import { Stack, Typography } from '@eventbrite/marmalade';
import { TimeSlotList, type TimeSlotProps } from '@eventbrite/timed-entry';
import React, { FC } from 'react';
import {
    CalendarType,
    InfiniteCalendarSeriesNamespace,
} from '../../../../state/infiniteCalendarSeries';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../../utils/rebrand';
import defaultStyles from '../TimeSlot.module.scss';
import rebrandStyles from '../TimeSlot.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

type TimeSessionProps = {
    sessions: Array<TimeSlotProps>;
    sessionsInfoText: string;
    onSessionClick: (
        sessionId: string,
        sessionLabel: string,
        calendarType: CalendarType,
    ) => void;
} & Pick<
    InfiniteCalendarSeriesNamespace,
    | 'selectedSessionId'
    | 'calendarType'
    | 'locale'
    | 'timezone'
    | 'isAppRebrandActive'
>;

const TimeSlotSelector: FC<TimeSessionProps> = ({
    sessions,
    onSessionClick,
    sessionsInfoText,
    isAppRebrandActive,
    selectedSessionId,
    calendarType,
    locale,
    timezone,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    const sessionsInfo = sessionsInfoText ? (
        <Typography
            variant="body-md"
            color="neutral-600"
            className={styles.sessionsInfoText}
            data-testid="session-info-text"
        >
            {sessionsInfoText.toString()}
        </Typography>
    ) : null;

    const handleSessionClick = (timeSlot: TimeSlotProps) =>
        onSessionClick(timeSlot.id, timeSlot.startDatetime, calendarType);

    return (
        <Stack space="spacing-md" className={styles.timeSlotContainer}>
            {sessionsInfo}
            <TimeSlotList
                timeSlots={sessions}
                handleTimeClick={handleSessionClick}
                selectedId={selectedSessionId}
                selectedSlotClassName={styles.selectedSlot}
                disabledSlotClassName={styles.disabledSlot}
                locale={locale}
                timezone={timezone}
            />
        </Stack>
    );
};

export default TimeSlotSelector;
